import { DISPOSE_STORE as DISPOSE_ACTION_TYPE } from './constants';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { disposableEpic } from './controllers/disposable-epic';
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { makeDisposable } from './controllers/disposable-store';

export const DISPOSE_ACTION = { type: DISPOSE_ACTION_TYPE } as const;
